// src/components/ReportBarChart.js
import React from "react";
import Chart from "react-apexcharts";

const ReportBarChart = ({ sectionCounts }) => {
  // Prepare data for the chart
  const options = {
    chart: {
      type: "bar",
      height: 520, // Set the desired height here
      width: 720, // Set the desired width here
      toolbar: {
        show: false, // Disable the menu
      },
    },
    xaxis: {
      categories: sectionCounts.labels,
      labels: {
        style: {
          fontWeight: "700",
          fontSize: "18px",
          colors: "#007bff", // Choose a color for section names
        },
      },
    },
    yaxis: {
      title: {
        text: "Counts", // Add the y-axis title
        style: {
          fontWeight: "bold",
          fontSize: "20px",
          color: "#007bff", // Choose a color for y-axis title
        },
      },
      labels: {
        style: {
          fontWeight: "600",
          fontSize: "14px",
          color: "#333", // Color for y-axis labels
        },
      },
    },
    legend: {
      show: false, // Disable the legend
    },
    plotOptions: {
      bar: {
        distributed: true, // Color each bar differently
      },
    },
    dataLabels: {
      enabled: false, // Disable data labels on bars
    },
  };

  const series = [
    {
      name: "Count",
      data: sectionCounts.values,
    },
  ];

  return (
    <Chart
      options={options}
      series={series}
      type="bar"
      height={520}
      width={720}
    />
  );
};

export default ReportBarChart;
